export default "/static/images/8fd76ba78fed6d33dec6392436ee1439.png";